import {useQuery} from "react-query";
import {apiV2} from "@/api/axiosConfig";
import {UserDataTypes} from "@/types/user-data-types";
import {isValidObjectID} from "@/lib/misc/isValidObjectID";

export const fetchUser = (id: string) =>
    apiV2.get<UserDataTypes>(`/users/${id}`).then(res => res.data);

export const useLoadUser = (id: string | null) =>
    useQuery(["user", id], () => fetchUser(id!), {
        enabled: isValidObjectID(id),
        staleTime: 5 * 60 * 1000,
    });
